import React from "react";
import {
  Popover,
  Position,
  Button,
  Shelf,
  Text,
  Toggle,
  Stack,
} from "@chaser/components";
import { ChevronDown, ChevronUp } from "lucide-react";
import { BillingPeriods } from "../../../../../util/constants";

import PlanComparisonGrid from "./PlanComparisonGrid";

import styles from "../Addons.module.scss";

const ComparePlansPopover = ({
  showComparePlans,
  setShowComparePlans,
  loadingSubscription,
  visiblePlans,
  currentPlanAmount,
  recurringSuffix,
  onSelectPlan,
  selectedOfferPeriod,
  setSelectedOfferPeriod,
  currencyCode,
  disabled = false,
}) => {
  const isMonthlyPeriod = selectedOfferPeriod !== BillingPeriods.YEARLY;

  return (
    <Popover
      open={showComparePlans}
      onOpenChange={setShowComparePlans}
      placement="bottom-end"
      position={Position.BOTTOM_RIGHT}
      contentClassName={styles.comparePlansPopover}
      target={(active) => (
        <Button
          appearance="secondary"
          size="narrow"
          icon={
            active ? (
              <ChevronUp size={14} className={styles.comparePlansButtonIcon} />
            ) : (
              <ChevronDown
                size={14}
                className={styles.comparePlansButtonIcon}
              />
            )
          }
          className={styles.comparePlansButton}
          disabled={loadingSubscription || disabled}
        >
          Compare plans
        </Button>
      )}
    >
      <div className={styles.comparePlansOverlay}>
        <Stack py="small">
          <Shelf
            alignItems="center"
            gap="small"
            className={styles.modulePlanPeriodToggle}
          >
            <Text>Monthly</Text>
            <Toggle
              toggleOn={!isMonthlyPeriod}
              handleToggle={() =>
                setSelectedOfferPeriod(
                  isMonthlyPeriod
                    ? BillingPeriods.YEARLY
                    : BillingPeriods.MONTHLY,
                )
              }
            />
            <Text>Annual</Text>
          </Shelf>
        </Stack>
        <PlanComparisonGrid
          visiblePlans={visiblePlans}
          currentPlanAmount={currentPlanAmount}
          recurringSuffix={recurringSuffix}
          onSelectPlan={onSelectPlan}
          actionMode="compare"
          currencyCode={currencyCode}
        />
      </div>
    </Popover>
  );
};

export default ComparePlansPopover;
